import type { SpinResponse } from "@slot/client-engine";
import { SECRET_BONUS_OFFER_ID } from "../../../features/secret-bonus/secretBonusOffer";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * The Secret Bonus lands (decision 51): a 2×2 L1 below the top row pays 0.20 and merges into two L2, and the candy
 * dropping into its column's gap is the Secret Bonus — on the top row, on the dead board the spin ends on. A tap on it
 * opens its offer until the next spin.
 */
export function secretBonus(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-secret-bonus", ...OFFLINE_ROUND })
    .baseSpin(
      {
        board: [
          ["L3", "L4", "L2", "H2", "L1", "L3"],
          ["L2", "H1", "L1", "L1", "L3", "L4"],
          ["L4", "L3", "L1", "L1", "H2", "L2"],
          ["L1", "L2", "L4", "L3", "L4", "L1"],
          ["H3", "L1", "L2", "L4", "L2", "L3"],
          ["L2", "L4", "H1", "L2", "L3", "H4"],
        ],
        refill: [[], [], ["SB"], ["L4"], [], []],
      },
      { secretBonus: { positionIndex: 2, offerIdentifier: SECRET_BONUS_OFFER_ID } },
    )
    .build();
}
